// src/components/Item/ItemItem.js

import React, { useEffect, useState } from "react";
import { FiTrash2, FiEdit2, FiCheck, FiClock } from "react-icons/fi";
import { toast } from "react-toastify";
import styles from "./ItemItem.module.css";
import { typeLabels } from "../../utils/items";

const ItemItem = ({
  item,
  onDelete,
  deleteConfirmMessage,
  onEdit,
  onCountSave,
  onHistoryClick,
  isSuperAdmin,
  onDistributionClick,
}) => {
  const [countInput, setCountInput] = useState(String(item.count ?? 0));
  const [saving, setSaving] = useState(false);

  // Sunucudan yeni değer gelince kutuyu güncelle
  useEffect(() => {
    setCountInput(String(item.count ?? 0));
  }, [item.count]);

  const isDirty = countInput !== String(item.count ?? 0);

  const handleDelete = () => {
    const id = item.assignedItemId || item._id;
    const message = deleteConfirmMessage
      ? deleteConfirmMessage(item)
      : "Bu öğeyi silmek istediğinizden emin misiniz?";

    if (onDelete && window.confirm(message)) {
      onDelete(id);
    }
  };

  const handleCountSave = async () => {
    if (!isDirty || saving) return;
    const parsed = Number(countInput);
    if (countInput.trim() === "" || !Number.isInteger(parsed) || parsed < 0) {
      toast.error("Miktar 0 veya daha büyük bir tam sayı olmalıdır");
      return;
    }
    setSaving(true);
    try {
      await onCountSave(item, parsed);
    } finally {
      setSaving(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleCountSave();
    } else if (e.key === "Escape") {
      setCountInput(String(item.count ?? 0));
    }
  };

  // stockUpdatedAt kontrolü
  const lastUpdateText = item.stockUpdatedAt
    ? new Date(item.stockUpdatedAt).toLocaleString("tr-TR")
    : "-";

  return (
    <div className={styles.row}>
      <div className={styles.cell}>{item.name || "Bilinmiyor"}</div>
      <div className={styles.cell}>{typeLabels[item.type] || "Bilinmiyor"}</div>
      <div className={styles.cell}>
        {onCountSave ? (
          <div className={styles.countEditor}>
            <input
              type="number"
              min="0"
              step="1"
              className={`${styles.countInput} ${isDirty ? styles.countInputDirty : ""}`}
              value={countInput}
              onChange={(e) => setCountInput(e.target.value)}
              onKeyDown={handleKeyDown}
              aria-label={`${item.name} miktarı`}
            />
            {isDirty && (
              <button
                className={`${styles.button} ${styles.saveCountButton}`}
                onClick={handleCountSave}
                disabled={saving}
                title="Kaydet (Enter)"
              >
                <FiCheck size={16} />
              </button>
            )}
          </div>
        ) : (
          item.count ?? 0
        )}
      </div>
      {/* Son Güncelleme */}
      <div className={styles.cell}>{lastUpdateText}</div>
      <div className={styles.cell}>
        {/* Ürün bilgisi düzenle (sadece admin, genel liste) */}
        {onEdit && (
          <button
            className={`${styles.button} ${styles.updateButton}`}
            onClick={() => onEdit(item)}
            title="Ürünü düzenle"
          >
            <FiEdit2 size={16} />
          </button>
        )}
        {/* Stok geçmişi */}
        {onHistoryClick && (
          <button
            className={`${styles.button} ${styles.updateButton}`}
            onClick={() => onHistoryClick(item)}
            title="Stok geçmişi"
          >
            <FiClock size={16} />
          </button>
        )}
        {/* Sil (sadece admin) */}
        {isSuperAdmin && onDelete && (
          <button
            className={`${styles.button} ${styles.deleteButton}`}
            onClick={handleDelete}
            title="Sil"
          >
            <FiTrash2 size={16} />
          </button>
        )}
        {/* Detay Butonu */}
        {isSuperAdmin && onDistributionClick && (
          <button
            className={`${styles.button} ${styles.detailButton}`}
            onClick={() => onDistributionClick(item)}
          >
            Detay
          </button>
        )}
      </div>
    </div>
  );
};

export default ItemItem;
